import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as newsFeedActions from './../../actions/newsFeedActions';
import * as dashboardActions from './../../actions/dashboardActions';
import * as commonActions from './../../actions/commonActions';
import * as authActions from '../../redux/modules/auth';
import styles from './NewsFeedComponent.less';
import moment from 'moment';
import appConstants from './../../appConstants';
import Modal from 'react-modal';
import i18next from 'i18next';
import { applyStyle,applyToHover,setDirection } from './../../utils/utils';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';

// const elementsData = [
//   {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"card-header", "elementType":"tag", "applyTo":"alternative", "tagNames":"tr"},
//   {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"}
// ];

const directionData = [
  {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"widgetbody","elementType":"normal", "applyTo":"all", "tagNames":"div"}
];

@connect(
  state => ({
    modal:state.dashboardRoot.commonReducer.modal,
    newsFeedData:state.dashboardRoot.newsFeedReducer.newsFeedData,
    userDetail:state.auth.userDetail,
    // selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
    checkClickOnAddWidgetFlag:state.dashboardRoot.commonReducer.checkClickOnAddWidgetFlag,
    fontSize:state.auth.userDetail.fontSize,
    selectedLang:state.dashboardRoot.commonReducer.selectedLang,
    language:state.dashboardRoot.commonReducer.language
  }),
  {...dashboardActions, ...commonActions, ...newsFeedActions, ...authActions}
)

export default class NewsFeedComponent extends Component {
  static propTypes = {
    CloseIcon:PropTypes.object,
    keyValue:PropTypes.string.isRequired,
    deleteWidget:PropTypes.func,
    showPreview:PropTypes.object,
    popoutIcon:PropTypes.object,
    newsFeedData:PropTypes.array,
    userDetail:PropTypes.object,
  };

  state = {
    clickedRemove: false,
    shownFModal:false,
    nFData:'',
    nFURL:'',
    nFTime:''
  }

  componentDidMount(){
    const thisComponent = ReactDOM.findDOMNode(this);
   // //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
  }

  componentWillReceiveProps(nextProps){
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   //applyStyle(thisComponent, allCssStyleRules, elementsData);
    // }
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
    }
  }

  nFModal=(data,url,time)=>{
    try{
      this.setState({shownFModal:true});
      this.setState({nFData:data});
      this.setState({nFURL:url});
      this.setState({nFTime:time});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'nFModal', component:"NewsFeedComponent"});
    }
  }

  closeModal = () => {
    try{
      this.setState({shownFModal:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeModal', component:"NewsFeedComponent"});
    }
  }

  convertUnicode = (input) => {
    try{
      return input.replace(/\\u(\w{4,4})/g,function(a,b) {
        var charcode = parseInt(b,16);
        return String.fromCharCode(charcode);
      });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'convertUnicode', component:"NewsFeedComponent"});
    }
  }

  render() {
    const selectedfont_size = "fontSize_"+this.props.userDetail.fontSize;
    const CloseIcon = <MUIIconWithTooltip icon={'Close'} className="closeBtn commonCloseIcon" title={i18next.t("close")}/>
    return (
      <div id="newsFeedMainDiv" className={`${styles.widgetbody} ${selectedfont_size} widgetbody ${this.props.language}`} >
        <Modal isOpen={this.state.shownFModal} contentLabel={i18next.t("msgfrmDealer")} className={styles.nFContainer} id="nwfModal">
          <div className={`${styles.mdlWrap} mdlWrap`} >
            <div className={`${styles.header} header`} >
              <span className={`${styles.nfTitle} ${selectedfont_size}`}>{i18next.t("newsFeed")}</span>
              <span className={`${styles.closeImg} closeIcon commonCloseIcon`} onClick={this.closeModal} id="nwfCloseModal" style={this.props.selectedLang.commonCloseIcon}>{CloseIcon}</span>
            </div>

            <div className={`${styles.nFDiv}`} style={this.props.selectedLang.nFDiv}>
              <div className={`${styles.nFLabel} ${selectedfont_size}`} style={this.props.selectedLang.nFLabel}>
                <label className={`${styles.label}`} style={this.props.selectedLang.nLabel}>{i18next.t("time")}:</label>
                <p style={this.props.selectedLang.eventTimeDiv}>{this.state.nFTime}</p>
              </div>

              <div className={`${styles.nFLabel} ${selectedfont_size}`} style={this.props.selectedLang.nFLabel}>
                <label className={`${styles.label}`} style={this.props.selectedLang.nLabel}>{i18next.t("URL")}:</label>
                <p>
                  <a href={(!/^(f|ht)tps?:\/\//i.test(this.state.nFURL)) ? 'http://' + encodeURIComponent((this.state.nFURL).trim()) : (this.state.nFURL).trim()} target="_blank">{this.state.nFURL}</a>
                </p>
              </div>

              <div className={`${styles.nFLabeldata} ${selectedfont_size}`} style={this.props.selectedLang.nFLabel}>
                <label className={`${styles.label}`} style={this.props.selectedLang.nLabel}>{i18next.t("newsFeed")}:</label>
                <p className={`${styles.nFp}`} style={this.props.selectedLang.nFPrgH}>
                  <textarea  className="form-control" rows="8" value={this.convertUnicode(this.state.nFData)} readOnly />
                </p>
              </div>
            </div>
          </div>
        </Modal>

        {this.props.newsFeedData.length === 0 ?
          <div className={styles.noDataDiv}><p>{i18next.t("noDataAvlMsg")}</p></div>
        :
          <table className={`${styles.tablebordered} table`} style={this.props.selectedLang.nfTable} id="nFTableDiv">
            <tbody>
              {this.props.newsFeedData.map((data, index) => {
                const time = new Date(data.CT);
                const dateFormate=appConstants.actTimeDateTimeFormatter;
                const CT_value=moment(data.CT).format(appConstants.actTimeDateTimeFormatter);
                return (
                  <tr onDoubleClick={() => this.nFModal(data.NF,data.URL,CT_value)} id="nwfTableRow">
                    <td className={`${selectedfont_size} eventTimeCell`} id="nwfdate" style={this.props.selectedLang.eventTimeDiv}>{CT_value}</td>
                    <td className={`${selectedfont_size}`} id="nwfURL">
                      {data.URL ?
                        <a className={`${styles.webIcon}`} href={(!/^(f|ht)tps?:\/\//i.test(data.URL)) ? 'http://' + encodeURIComponent((data.URL).trim()) : (data.URL).trim()} target="_blank">
                          <img src="/images/url.png" width="16" height="16" />
                        </a>
                      : null}
                    </td>
                    <td className="outerspantd" id="nwfComment" style={this.props.selectedLang.outerspantd}>
                      <span className={`${selectedfont_size}`}>
                        {this.convertUnicode(data.NF)}
                        {this.convertUnicode(data.NF).length > 180 ?
                          <a className="longCommentLink" onClick={() => this.nFModal(data.NF,data.URL,CT_value)} id="nwfCommentLink">....</a>
                        : null}
                      </span>
                    </td>
                  </tr>
                );
              }) }
            </tbody>
          </table>
        }
      </div>
    );
  }
}
